var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#ADADD0",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20c-3 0-5-1.5-5-5V8c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5v7c0 3.5-2 5-5 5H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5 12.87 11c-1.03.82-2.72.82-3.75 0L6 8.5",
    opacity: 0.596
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompliance);
export default __webpack_public_path__ + "static/media/icon-compliance.9d0156de6d7691b187660d406ba35303.svg";
export { ForwardRef as ReactComponent };